export type ConcentricInsetType = {
    horizontal: number;
    vertical: number;
};

export type ConcentricConstantType = {
    inset: number | ConcentricInsetType;
    isCapsuleExempt?: boolean;
    outer: number;
    role: number;
};

export const CAPSULE_THRESHOLD = 999;

const getConcentricInset = (inset: number | ConcentricInsetType): number => {
    if(typeof inset === "number") {
        return inset;
    }

    return Math.min(inset.horizontal, inset.vertical);
};

export const concentric = ({
    isCapsuleExempt = true,
    inset,
    outer,
    role
}: ConcentricConstantType): number => {
    if(isCapsuleExempt && role >= CAPSULE_THRESHOLD) {
        return role;
    }

    const currentInset = getConcentricInset(inset);

    if(currentInset >= outer) {
        return Math.min(role, outer);
    }

    return Math.max(0, Math.min(role, outer, outer - currentInset));
};
